/*
 * @description: 
 * @author: Jason Wong
 * @since: 2024-10-21 15:21:05
 */

import env from "../configs/env";

//拼接两段url路径
export function joinUrl(url1, url2) {
  url1 = url1.trim();
  url2 = url2.trim();
  if (url1.endsWith("/") && url2.startsWith("/")) {
    return url1 + url2.slice(1);
  } else if (url1.endsWith("/") || url2.startsWith("/")) {
    return url1 + url2;
  } else {
    return url1 + "/" + url2;
  }
}

export function assembleWSUrl(urlPart) {
  if (env.apiBaseUri.startsWith("http")) {
    let temp = env.apiBaseUri;
    temp = temp.startsWith("http://") ? temp.replace("http://", "ws://") : temp.replace("https://", "wss://");
    return joinUrl(temp, urlPart);
  } else {
    return joinUrl(
      (window.location.protocol == "http:" ? "ws://" : "wss://") + window.location.host + env.apiBaseUri,
      urlPart
    );
  }
}